import React, { useCallback, useState } from 'react';
import { Field, UseFieldConfig } from 'react-final-form';
import EyeVisibillityOnIcon from 'icons/EyeVisibillityOnIcon.icon';
import EyeVisibillityOffIcon from 'icons/EyeVisibillityOffIcon.icon';
import InputField from 'components/InputField/InputField.component';
import { Button } from 'ncoded-component-library';
import validations from 'validations';
import { getClass, BASE_CLASS as defaultClassName } from './utils';
import classNames from 'classnames';
import { ExtractPropTypes } from 'types';

import './PasswordField.styles.scss';

type PasswordFieldProps = ExtractPropTypes<typeof InputField>;

const PasswordField: React.FC<
  PasswordFieldProps & UseFieldConfig<string, string>
> = ({ required = true, validate, className, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const classes = classNames(defaultClassName, className, getClass`__field`);

  const toggleVisibility = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const passwordValidation = validate || validations.passwordValidate();

  const icon = showPassword ? (
    <EyeVisibillityOnIcon />
  ) : (
    <EyeVisibillityOffIcon />
  );

  return (
    <Field
      name="password"
      validate={validations.composeValidators(passwordValidation)}
      className={classes}
      required={required}
      component={InputField}
      type={showPassword ? 'text' : 'password'}
      suffixNode={
        <Button onClick={toggleVisibility} className="fm-password-button">
          {icon}
        </Button>
      }
      {...props}
    />
  );
};

export default PasswordField;
